import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** TokenProperty property - Definition */
export class DocsBlockTokenPropertyPropertyDefinition extends DocsBlockPropertyDefinition {
}
